import { render, staticRenderFns } from "./pact.vue?vue&type=template&id=329b8b49&"
import script from "./pact.vue?vue&type=script&lang=js&"
export * from "./pact.vue?vue&type=script&lang=js&"
import style0 from "./pact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports